import {
  flatMap,
  pipe,
  succeed,
  fail,
  type Effect,
  mapErrorAsync,
  type Async,
  tryMapAsync,
  catchError,
  fromExpression,
  tryPromiseImmediate,
  returnsEffect,
} from "@otto-ec/assets-core-utils/nano-effect";
import { LoadError } from "./loadError";

/**
 *
 *
 *
 */
const checkResponseError = returnsEffect((allowedCodes: number[]) =>
  catchError((response: Response) =>
    pipe(
      /*                                                                                  */
      !!response.headers.get("Cache-Control")?.includes("no-transform") &&
        /*                                                                                  */
        (allowedCodes.length === 0 || allowedCodes.includes(response.status)),

      /*                                                                 */
      (hasContent) => fail([response, hasContent] as const),
    ),
  ),
);

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const fetchFromUrl = (
  url: string,
  allowedCodes: number[],
  /*                                        */
  controller = new AbortController(),
): Effect<string, Error | LoadError, Async> =>
  pipe(
    /*                          */
    tryPromiseImmediate(
      () =>
        fetch(url, {
          redirect: "manual",
          headers: { Accept: "text/html" },
          signal: controller.signal,
        }),
      (e) => [e as Error, false] as const,
    ),

    /*                                              */
    flatMap((response) =>
      pipe(
        /*                                              */
        fromExpression(
          response.ok && !!response.headers.get("Content-Type")?.includes("html")
            ? succeed(response)
            : fail(response),
        ),

        /*                                                 */
        checkResponseError(allowedCodes),
      ),
    ),

    /*                                                                        */
    mapErrorAsync(async ([err, hasContent]) => {
      if (hasContent) {
        /*                                                   */
        return new LoadError("Error Response", err, await err.text());
      }

      /*                                                 */
      controller.abort();
      return err instanceof Error ? err : new LoadError("Bad response", err, undefined);
    }),

    /*                 */
    tryMapAsync(
      (response) => response.text(),
      (e) => new Error(`Error loading content: ${e}`),
    ),
  );
